import React, { useState } from 'react';
import EmailComposer from './EmailComposer';

interface Props {
  to?: string;
  name?: string;
}

const templates = [
  { key: 'intro', label: 'Send intro deck' },
  { key: 'quote', label: 'Prepare quote' },
  { key: 'followup', label: 'Follow up' },
];

export const EmailTemplateButtons: React.FC<Props> = ({ to, name }) => {
  const [emailComposer, setEmailComposer] = useState<{
    isOpen: boolean;
    template?: 'intro' | 'quote' | 'followup' | 'custom';
  }>({ isOpen: false });

  const openComposer = (template: 'intro' | 'quote' | 'followup' | 'custom') => {
    setEmailComposer({ isOpen: true, template });
  };

  const closeComposer = () => {
    setEmailComposer({ isOpen: false });
  };

  return (
    <>
      <div className="flex flex-wrap gap-2">
        {templates.map(t => (
          <button 
            key={t.key} 
            className="px-2 py-1 bg-gray-700 hover:bg-gray-600 rounded text-xs text-white transition-colors" 
            onClick={() => openComposer(t.key as any)}
          >
            {t.label}
          </button>
        ))}
        <button 
          className="px-2 py-1 bg-primary-600 hover:bg-primary-700 rounded text-xs text-white transition-colors" 
          onClick={() => openComposer('custom')}
        >
          Compose Email
        </button>
      </div>

      <EmailComposer
        isOpen={emailComposer.isOpen}
        onClose={closeComposer}
        to={to}
        template={emailComposer.template}
        recipientName={name}
      />
    </>
  );
};

export default EmailTemplateButtons;


